import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'components/pure/utils/form/SelectField';
import {List} from 'immutable';
import {groupings} from 'components/pure/charts/trend/index';
import LegendRow from 'components/pure/charts/trend/LegendRow';

/**
 * A legend that provides grouping options - best and worst, most improved, etc
 *
 * "dumb" - needs that info passed to it, see groupings and trendMetrics
 */
export class GroupingTrendChartLegend extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.state = {
      selectedGroup: undefined,
    };
  }

  componentDidMount() {
    this.setState({
      selectedGroup: this.props.preselectedGroup,
    });
  }

  onChange(group) {
    const {onTrendListChange, trendMetrics} = this.props;

    const selectedTrends = groupings()[group](trendMetrics);

    this.setState({selectedGroup: group});
    onTrendListChange(List(selectedTrends));
  }

  render() {
    const {hoverIndex, pinned, togglePin, legendMouseEnter, legendMouseLeave, filteredTrends} =
      this.props;
    const {selectedGroup} = this.state;

    const dropdownValues = Object.keys(groupings()).map(k => ({
      label: k,
      value: k,
    }));

    return (
      <div className="legend grouped">
        <SelectField
          tether
          options={dropdownValues}
          value={selectedGroup}
          onChange={this.onChange}
          hideResetButton
        />
        <ul className="grouped">
          {filteredTrends.map((item, index) => (
            <LegendRow
              key={index}
              item={item}
              index={index}
              hoverIndex={hoverIndex}
              legendMouseEnter={legendMouseEnter}
              legendMouseLeave={legendMouseLeave}
              togglePin={togglePin}
              pinned={pinned}
            />
          ))}
        </ul>
      </div>
    );
  }
}

GroupingTrendChartLegend.propTypes = {
  trends: PropTypes.any,
  trendMetrics: PropTypes.any,
  filteredTrends: PropTypes.instanceOf(List),
  preselectedGroup: PropTypes.any,
  hoverIndex: PropTypes.number,
  pinned: PropTypes.bool,
  legendMouseEnter: PropTypes.func,
  legendMouseLeave: PropTypes.func,
  togglePin: PropTypes.func,
  onTrendListChange: PropTypes.any,
};
